import { Service, inject } from '@angular/core'
import { ApiService } from '../api.service'
import {
  CancelReservationBody,
  CreateManagedReservationBody,
  DeleteEntityResponse,
  EditReservationBody,
  EditReservationNoteBody,
  GetHistoryResponse,
  GetManagedReservationResponse,
  GetManagedReservationsQuery,
  ManagedReservation,
  ManagedReservationDetail,
} from '@seiri/shared/common'

@Service()
export class ManageReservationApiService {
  private readonly api = inject(ApiService)

  getManagedReservations(entityId: string, query: GetManagedReservationsQuery = {}, init?: RequestInit) {
    const url = this.api.createURL(`manage/entities/${entityId}/reservations`)
    url.search = this.api.toQueryParams(query)
    return this.api.protectedFetchJson<GetManagedReservationResponse>(url, { ...init })
  }

  getManagedReservation(entityId: string, reservationId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationDetail>(
      `manage/entities/${entityId}/reservations/${reservationId}`,
      { ...init },
    )
  }

  getReservationHistory(entityId: string, reservationId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetHistoryResponse>(
      `manage/entities/${entityId}/reservations/${reservationId}/history`,
      { ...init },
    )
  }

  createReservation(entityId: string, body: CreateManagedReservationBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservation>(`manage/entities/${entityId}/reservations`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editReservation(entityId: string, reservationId: string, body: EditReservationBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationDetail>(
      `manage/entities/${entityId}/reservations/${reservationId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  editReservationNote(entityId: string, reservationId: string, body: EditReservationNoteBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationDetail>(
      `manage/entities/${entityId}/reservations/${reservationId}/note`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  cancelReservation(entityId: string, reservationId: string, body: CancelReservationBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationDetail>(
      `manage/entities/${entityId}/reservations/${reservationId}/cancel`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  deleteReservation(entityId: string, reservationId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(
      `manage/entities/${entityId}/reservations/${reservationId}`,
      {
        method: 'DELETE',
        ...init,
      },
    )
  }
}
